import { combineReducers } from "redux"

import {
  REQUEST_START_REGISTRATION,
  SUCCESS_START_REGISTRATION,
  FAILURE_START_REGISTRATION,
  REQUEST_CLEAR_REGISTRATION_INFO,

  REQUEST_FINISH_REGISTRATION,
  SUCCESS_FINISH_REGISTRATION,
  FAILURE_FINISH_REGISTRATION

} from "./actions"

export const INIT_STATE = {
  isFetching: false,
  payload: null,
  error: null
};

export const startRegistration = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_START_REGISTRATION:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_START_REGISTRATION:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      }
    case FAILURE_START_REGISTRATION:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };

    case REQUEST_CLEAR_REGISTRATION_INFO:
      return INIT_STATE

    default:
      return state;
  }
};

export const finishRegistration = (state = INIT_STATE, action) => {
  switch (action.type) {
    case REQUEST_FINISH_REGISTRATION:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case SUCCESS_FINISH_REGISTRATION:
      return {
        ...state,
        isFetching: false,
        payload: action.payload,
        error: null
      }
    case FAILURE_FINISH_REGISTRATION:
      return {
        ...state,
        isFetching: false,
        payload: null,
        error: action.error
      };

    default:
      return state;
  }
}

export const notaryRegistration = combineReducers({startRegistration, finishRegistration} )